import React, { useCallback, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import Menu from './Menu';
import HeaderSideMenu from './HeaderSideMenu';
import useWindowSize from '../../hooks/useWindowSize';
import BurgerButton from '../buttons/Burger';
import { setMenuOpened as setMenuOpenedAction } from '../../actions/LayoutActions';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/header.scss';

const propTypes = {
    setMenuOpened: PropTypes.func.isRequired,
    menuOpened: PropTypes.bool.isRequired,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#ffffff',
    className: null,
};

const Header = ({ setMenuOpened, menuOpened, color, className }) => {
    const refContainer = useRef(null);
    const onMenuClick = useCallback(() => {
        setMenuOpened(!menuOpened);
    }, [menuOpened]);

    const closeMenu = useCallback(() => setMenuOpened(false), [setMenuOpened]);

    useEffect(() => {
        if (menuOpened) {
            disableBodyScroll(refContainer.current);
        } else {
            enableBodyScroll(refContainer.current);
        }
        return () => {
            enableBodyScroll(refContainer.current);
        };
    }, [menuOpened]);

    const menuLayout = width => {
        if (width > 500) {
            return <Menu className={styles.topMenu} />;
        }
        return (
            <div className={styles.side}>
                <BurgerButton
                    className={styles.burger}
                    color={color}
                    menuOpened={menuOpened}
                    onClick={onMenuClick}
                />
                <HeaderSideMenu
                    menuOpened={menuOpened}
                    onClickItem={closeMenu}
                    className={styles.sideMenu}
                />
            </div>
        );
    };

    const size = useWindowSize();

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.bar}>
                <div className={styles.inner}>{menuLayout(size.width)}</div>
            </div>
        </div>
    );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

const WithStateContainer = connect(
    ({ layout: { menuOpened } }) => ({
        menuOpened,
    }),
    dispatch => ({
        setMenuOpened: value => dispatch(setMenuOpenedAction(value)),
    }),
)(Header);

export default WithStateContainer;
